import axios, { AxiosError } from 'axios'
import * as E from 'fp-ts/es6/Either'
import * as TE from 'fp-ts/es6/TaskEither'
import { pipe, identity } from 'fp-ts/es6/function'
import { CrowdSurfConfig } from './appconfig'

export type CSRFTokenFetchError = 'UnknownCSRFFetchError' | 'UnauthenticatedCSRFFetchError'
export type CSRFToken = string

export const teGetCsrfToken = ({ authentication }: CrowdSurfConfig): TE.TaskEither<CSRFTokenFetchError, CSRFToken> =>
  pipe(
    TE.tryCatch(
      () =>
        axios(authentication.apiEndpoint, {
          method: 'POST',
          headers: {
            'x-amz-request-csrf-token': 'true',
            'Amazon-Advertising-API-AdvertiserId': '',
            'Amazon-Advertising-API-CSRF-Data': authentication.apiClientId,
            'Amazon-Advertising-API-ClientId': authentication.apiClientId,
            'Amazon-Advertising-API-MarketplaceId': authentication.apiMarketplaceId,
          },
          data: {
            // We absolutely have to pass valid GQL to hit this, but it doesn't have to actually mean anything.
            operationName: 'aFakeOperation',
            query: 'query aFakeOperation { partner {id} }',
          },
          withCredentials: true,
        }),
      identity,
    ),
    TE.chainEitherK((success: { data?: { data?: { 'x-csrf-token': string } } }) => {
      if (success?.data?.data && success?.data?.data['x-csrf-token']) {
        return E.right(success?.data?.data['x-csrf-token'])
      } else {
        return E.left('Unexpected Error parsing CSRF Token')
      }
    }),
    TE.mapLeft((error: unknown) => {
      if (
        (error as AxiosError).code === '401' ||
        ((error as AxiosError)?.message && (error as AxiosError)?.message.indexOf('401') > 0) ||
        (error as AxiosError).code === '500'
      ) {
        // This is where we will end up if the user is not authenticated (has valid AuthPortal cookies, either at-tacbus or at-main)
        return 'UnauthenticatedCSRFFetchError' as CSRFTokenFetchError
      } else {
        // We're treating unknown CSRF errors as un-authenticated since there is no remedy for UnknownCSRF errors.
        return 'UnknownCSRFFetchError' as CSRFTokenFetchError
      }
    }),
  )
